import ATableAccess from "./aTableAccess";

class OrderAccess extends ATableAccess {}

export default OrderAccess;
